import React from "react";
import {
    BusinessSolutionHeroBanner,
    BusinessSolutionTabWidget,
    SwitchOverviewWidget,
    CashlessBusinessOverviewWidget,
    SecurePayOverviewWidget,
    AdvertiseBusinessOverviewWidget,
    DoMoreBusinessBanner,
} from "pageComponents/business-solutions";
import SEO from "components/seo";

import Layout from "components/Layout/Layout";
import "./index.css";
const BusinessSolution = () => (
    <Layout>
        <SEO
            title="Contactless payment solutions for Businesses in India | PhonePe"
            description="PhonePe Business Solutions enable fast, contactless &amp; secure online payments for SMBs in India. Grow your business with PhonePe by accepting payments at store &amp; online. Download the App!"
            url="https://www.phonepe.com/business-solutions/"
        />
        <BusinessSolutionHeroBanner />
        <BusinessSolutionTabWidget />
        <SwitchOverviewWidget />
        <CashlessBusinessOverviewWidget />
        <SecurePayOverviewWidget />
        <AdvertiseBusinessOverviewWidget />
        <DoMoreBusinessBanner />
    </Layout>
);

export default BusinessSolution;
